import { GetDistributorDetailsResponse } from '@Common/types/bo_external/distributor/details';

export const distributorTranslations = {
  title: 'Distributor Dashboard',
  sub_titles: {
    dashboard: 'Dashboard',
    details: 'Details',
    address: 'Address',
  },
  fields: {
    id: 'Distributor ID',
    firstname: 'First name',
    lastname: 'Last name',
    orias_code: 'ORIAS code',
    email: 'Email',
    landline: 'Landline phone number',
    phone_number: 'Mobile phone number',
    collective_inspector_email: 'Email from the collective inspector',
    created_at: 'Created at',
    street: 'Street',
    postal_code: 'Postal Code',
    city: 'City',
    country_code: 'Country of Residence',
    company_name: 'Company name',
  } satisfies Record<keyof GetDistributorDetailsResponse, string>,
  dashboard: {
    outstanding_timeline: {
      title: 'Total outstanding amounts',
      range: {
        today: 'Today',
        last_n_days: 'Last %{days} days',
        last_week: 'Last week',
        last_month: 'Last month',
        last_year: 'Last year',
      },
    },
    outstanding_breakdown: {
      title: 'Current total outstanding amounts breakdown',
      contracts: 'Per contract name',
      plans: 'Per product type',
      instruments: 'Per funds',
    },
    companies_employees_distribution: {
      companies: {
        title: 'Companies',
        active: 'Active',
        inactive: 'Inactive',
        total: 'Number of companies',
      },
      employees: {
        title: 'Employees',
        active: 'Active',
        inactive: 'Inactive',
        total: 'Number of employees',
      },
    },
    tabs: {
      standard: 'Standard',
      er: 'ER',
    },
  },
};
